import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { IMAGES } from "../config";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("dmedia_token", data.token);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-charcoal text-offwhite flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <img src={IMAGES.logo} alt="DMEDIA CLUB" className="h-9 w-auto mb-8 brightness-0 invert" />
        <p className="overline text-plum mb-2" style={{ color: "#e59ec1" }}>Lead Dashboard</p>
        <h1 className="display text-4xl mb-8">Admin Sign In</h1>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-xs uppercase tracking-widest text-offwhite/60 mb-2">Email</label>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border border-offwhite/25 px-4 py-3 text-sm focus:border-plum focus:outline-none" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-offwhite/60 mb-2">Password</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border border-offwhite/25 px-4 py-3 text-sm focus:border-plum focus:outline-none" />
          </div>
          {error && <p className="text-sm text-plum" data-testid="admin-login-error" style={{ color: "#e59ec1" }}>{error}</p>}
          <button data-testid="admin-login-btn" type="submit" disabled={loading}
            className="w-full bg-plum text-white py-4 text-sm tracking-wide hover:bg-plum-deep transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
            {loading ? <><Loader2 size={16} className="animate-spin" /> Signing in…</> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
